module.exports = __webpack_public_path__ + "media/images/favicons/svg-7754ef71f5dc5b06efac05a103519c1e.svg";